// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"d240fff1","302":"74a65caa","548":"04c7a38b"}[chunkId] + ".css";
};